import { Languages } from "../../../enums/languages";

const addFileToReqModalLang = {
    "modal-title": {
        [Languages.Hebrew]: { default: "הוספת קובץ לבקשה" },
        [Languages.Arabic]: { default: "إضافة ملف إلى الطلب" },
        [Languages.English]: { default: "Add File to Request" }
    },
    "form": {
        "file-input-label": {
            [Languages.Hebrew]: { default: "בחר קובץ להעלאה" },
            [Languages.Arabic]: { default: "اختر ملفًا للتحميل" },
            [Languages.English]: { default: "Select a file to upload" }
        },
        "send-file-btn": {
            [Languages.Hebrew]: { default: "שלח קובץ" },
            [Languages.Arabic]: { default: "إرسال الملف" },
            [Languages.English]: { default: "Send File" }
        },
        "form-error": {
            [Languages.Hebrew]: { default: "שגיאה בטופס: אנא בחר קובץ להעלאה" },
            [Languages.Arabic]: { default: "خطأ في النموذج: يرجى اختيار ملف للتحميل" },
            [Languages.English]: { default: "Form Error: Please select a file to upload" }
        }
    },
    "success-msg": {
        [Languages.Hebrew]: { default: "הקובץ הועלה בהצלחה!" },
        [Languages.Arabic]: { default: "تم تحميل الملف بنجاح!" },
        [Languages.English]: { default: "File uploaded successfully!" }
    }
};

export default addFileToReqModalLang;